// import axios from 'axios';

// // Create an axios instance with default configuration
// const api = axios.create({
//     baseURL: 'https://admin.foodlink.ma/api', // Fixed IP address format
//     timeout: 7000, 
//     headers: {
//         'Content-Type': 'application/json'
//     },
//     withCredentials: true
// });

// // Request interceptor
// api.interceptors.request.use(
//     (config) => {
//         // You can add authentication headers or other request modifications here
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

// // Response interceptor
// api.interceptors.response.use(
//     (response) => {
//         return response;
//     },
//     (error) => {
//         // Handle errors globally
//         return Promise.reject(error);
//     }
// );

// // Contact API functions
// export const sendContactData = async (contactData) => {
//     try {
//         const response = await api.post('/contact', contactData);
//         return response.data;
//     } catch (error) {
//         throw error;
//     }
// };

// Contact API functions
// export const sendContactData = async (contactData) => {
//     console.log("axios file data lyoum" +contactData)
//     try {
//         const response = await api.post('/contact', contactData);
//             console.log(response.data)
//             // throw new Error('No data received from server');
//             return response.data;
//     } catch (error) {
//         if (error.response) {
//             // The server responded with a status code outside the 2xx range
//             console.log(error.response.data.message)
//             throw new Error(error.response.data.message || 'Server error occurred');
//         } else if (error.request) {
//             // The request was made but no response was received
//             console.log("error request" + error.request)
//             throw new Error('No response received from server');
//         } else {
//             // Something happened in setting up the request
//             console.log("error setting up the request" + error)
//             throw new Error('Error setting up the request');
//         }
//     }
// };


// export default api;
import axios from 'axios';


const api = axios.create({
    baseURL: 'https://foodlink.ma/api',  
    // baseURL : 'http://127.0.0.1:8000/api' , 
    timeout: 5000, 
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: false
});


api.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => Promise.reject(error)
);


api.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
);


export const sendContactData = async (contactData) => {
    try {
        const response = await api.post('/contact', contactData);
        return response.data || Promise.reject(new Error('No data received from server'));
    } catch (error) {
        console.error("Error in sendContactData:", error); 

        if (error.response) {
            throw new Error(error.response.data.message || 'Server error occurred');
        } else if (error.request) {
            throw new Error('No response received from server');
        } else {
            throw new Error('Error setting up the request');
        }
    }
};

export default api;
